import { createContext } from 'react';

const ConfirmModalContext = createContext(null);

export default ConfirmModalContext;
